import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/bywe-inv.svg")